
import { Component, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import { VuetifyMixin, MyCoachMixin, CoachRoutingMixin, BAIconsMixin, PaginatedTableMixin, StringsMixin } from "@/mixins";
import { DataTableHeader } from 'vuetify';
import { RepositoryQuery, QueryOptions, PaginatedResponse } from '@/../types/interfaces';
import { ScoutingReportModel, ScoutingReportModelEx } from '@/models/scoutingReport/ScoutingReportModel';
import { scoutingReportApi } from "@/api/ScoutingReportApi";
import ScoutingReportBrief from '@/components/profile/athlete/ScoutingReportBrief.vue';
import { PartialAthleteProfile, PartialCoachProfile, PartialTeam } from '@/models';
import { PartialOrganization } from '@/models/organization/OrganizationModel';
import { SportModel } from '@/models/sport';
import { ObjectCache } from '@/helpers';

@Component({
	components: {
		Page,
		ScoutingReportBrief,
	},
})
export default class CoachScoutingReportsSummary extends Mixins(PaginatedTableMixin, VuetifyMixin,	BAIconsMixin, StringsMixin, MyCoachMixin, CoachRoutingMixin) {
	search: string = '';
	scoutingReports: Array<ScoutingReportModelEx> = [];
	athletesCache: ObjectCache<PartialAthleteProfile> = new ObjectCache<PartialAthleteProfile>();
	coachesCache: ObjectCache<PartialCoachProfile> = new ObjectCache<PartialCoachProfile>();
	teamsCache: ObjectCache<PartialTeam> = new ObjectCache<PartialTeam>();
	orgsCache: ObjectCache<PartialOrganization> = new ObjectCache<PartialOrganization>();
	sportsCache: ObjectCache<SportModel> = new ObjectCache<SportModel>();

	mounted() {
		this.tableOptions.sortBy = ['createdAt'];
		this.tableOptions.sortDesc = [true];
		this.localForagePersistFields = [['search', ''],['tableOptions.page', 1],['tableOptions.itemsPerPage', 10]];
	}

	isShowComplete: boolean = true;
	isShowIncomplete: boolean = true;
	onShowComplete() {
		this.isShowComplete = !this.isShowComplete;
		this.updateFilter();
	}
	onShowIncomplete() {
		this.isShowIncomplete = !this.isShowIncomplete;
		this.updateFilter();
	}

	async loadDetails(reports: Array<ScoutingReportModel>): Promise<Array<ScoutingReportModelEx>> {
		return Promise.all(reports.map(async(report) => {
			const ex = new ScoutingReportModelEx();
			await ex.fromReport(report, this.athletesCache, this.coachesCache, this.teamsCache, this.orgsCache, this.sportsCache);
			return ex;
		}));
	}
	async loadTable() {
		this.isLoading = true;
		this.isLoaded = false;
		const query: RepositoryQuery<ScoutingReportModel> = this.TableQuery<ScoutingReportModel>(this.search, ['athleteId', 'notes', 'playerDetails.firstName', 'playerDetails.lastName', 'playerDetails.email', 'scoutingReport.gameDetails.teamName']);
		query.$match = {...query.$match, ...{ 'gameDetails.coachId': this.MyCoachId }};
		if( !this.isShowComplete && !this.isShowIncomplete ) query.$match = {...query.$match, ...{ 'id': 'none'}};
		else if( !this.isShowComplete ) query.$match = {...query.$match, ...{ 'submitted': false}};
		else if( !this.isShowIncomplete ) query.$match = {...query.$match, ...{ 'submitted': true}};
		const response: PaginatedResponse<ScoutingReportModel> = await scoutingReportApi.queryAll(query, this.TableQueryOptions);
		this.scoutingReports = await this.loadDetails(response.docs);
		this.dataItemsCount = response.total;
		this.isLoaded = true;
		this.isLoading = false;
	}

	get TableLoading(): boolean {
		return this.isLoading;
	}
	get PageLoading(): boolean {
		return this.TableLoading || this.isLoading;
	}

	get TableHeaders(): Array<DataTableHeader<any>> {
		let headers: Array<DataTableHeader<any>> = [
			{ text: 'Date', value: 'createdAt', sortable: true },
			{ text: 'Player', value: 'name', sortable: false },
			{ text: 'Team', value: 'team', sortable: false },
			{ text: 'Location', value: 'location', sortable: false },
			{ text: 'Status', value: 'submitted', sortable: false },
			{ text: 'Score', value: 'performance', sortable: false, width:'90', align:'center' },
			{ text: 'Potential', value: 'potential', sortable: false, width:'90', align:'center' },
			{ text: '', value: 'actions', sortable: false },
		];
		if( this.IsLargeScreen ) {
			headers.push({text: '', value: 'data-table-expand', sortable: false});
		}
		return headers;
	}

}
